if (!customElements.get('shoppable-layout-slider')) {
  class ShoppableLayoutSlider extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
      }
      this.init();
    }

    init () {
      const swiperEl = this.querySelector('.swiper-shoppable-slider');
      if (!swiperEl) return;
      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      this.swiper = new Swiper(swiperEl, {
        autoplay: false,
        spaceBetween: 10,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },
        breakpoints: {
          990: {
            spaceBetween: 20,
            // With exactly 3 slides there is nothing to slide; show them
            // edge-to-edge instead of leaving the quarter-slide peek empty.
            slidesPerView: slideCount === 3 ? 3 : 3.25
          },
          750: {
            spaceBetween: 20,
            slidesPerView: 2.5
          },
          550: {
            spaceBetween: 10,
            slidesPerView: 2
          },
          360: {
            slidesOffsetAfter: 50,
            spaceBetween: 10,
            slidesPerView: 1.4
          }
        },
        on: {
          beforeInit: () => {
            this.querySelectorAll('video').forEach((video, index) => {
              video.play();
            });
          },
          afterInit: () => {
            this.querySelector(
              '.swiper-shoppable-slider'
            ).removeAttribute('style');
            this.setLazyVideos();
          },
          slideChange: () => {
            this.setLazyVideos();
          }
        }
      });
    }

    setLazyVideos() {
      this.querySelectorAll('.swiper-slide-visible').forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) { video.play(); }
      });
      const activeIndex = this.swiper?.activeIndex;
      this.swiper?.slides?.forEach((slide, index) => {
        const videos = slide.querySelectorAll('video');
        videos.forEach(video => {
          if (index >= activeIndex) {
            video.play();
          } else {
            video.pause();
          }
        });
      });
    }

    open(event, index, id) {
      document.querySelector(`shoppable-drawer.shoppable-drawer--${id}`).openWithIndex(event, index);
    }
  }

  customElements.define('shoppable-layout-slider', ShoppableLayoutSlider);
}
